// Small localStorage cache so heavy pages paint instantly from the last result, then refresh quietly.
export const readPersisted = (key) => {
  try { return JSON.parse(localStorage.getItem(`kvc:${key}`))?.v ?? null; } catch { return null; }
};

export const writePersisted = (key, v) => {
  try { localStorage.setItem(`kvc:${key}`, JSON.stringify({ t: Date.now(), v })); } catch { /* quota full — skip */ }
};
